export default __webpack_public_path__ + "static/media/vault.5c2cae05.svg";